<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <div
            class="back-circle small mr-2 cursor-pointer"
            @click.prevent="visible=!visible"
          >
            <i
              v-if="visible"
              class="fa fa-chevron-up"
            />
            <i
              v-else
              class="fa fa-chevron-down"
            />
          </div>
          <h4 class="d-inline-block mb-0">
            {{ $t('vendorManagmentPuchaseChart.alStatistikas') }}
          </h4>
        </div>
        <div class="text-right">
          {{ $t('vendorManagmentPuchaseChart.son30Gn') }} <span class="text-primary">
            {{ $t('vendorManagmentPuchaseChart.azn', {toFixed: totalPurchases.toFixed(2)}) }}
          </span>
        </div>
      </div>

      <div
        v-show="visible"
        class=" mt-3"
      >
        <div class="m-2 text-left">
          <div class="checkbox checkbox-primary">
            <b-form-checkbox-group v-model="visibleLabels">
              <b-form-checkbox
                v-for="d in chartData.datasets"
                :name="`checkbox_${d.label}`"
                :value="d.label"
                :style="{color: d.backgroundColor } "
              >
                <span class="text-secondary">{{ d.label }}</span>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </div>
        </div>

        <LineChart
          v-if="ready"
          id="vendor-request-chart"
          :chart-options="options"
          :chart-data="chartData"
          :style="{

          }"
          @click="console.log($event)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {
  getCompanyPurchaseStatistics,

} from "@/repositories/VendorManagementRepository";

import 'chartjs-adapter-dayjs-3';

import {Line as LineChart} from 'vue-chartjs'
import {
  Chart as ChartJS,
  registerables
} from 'chart.js'

ChartJS.register(
    ...registerables
)

const dayjs = require('dayjs');

export default {

  components: {LineChart},
  data() {
    return {
      mediaBase: mediaBase,
      companyPurchaseStatistics: [],
      ready: false,
      visible: true,
      visibleLabels: [
        this.$t("vendorManagementChart.purchaseChart.label1"),
        this.$t("vendorManagementChart.purchaseChart.label2"),
        this.$t("vendorManagementChart.purchaseChart.label3"),
        this.$t("vendorManagementChart.purchaseChart.label4"),
      ],
      options: {
        responsive: true,
        aspectRatio: 16 / 5,
        interaction: {
          intersect: false,
          mode: 'index',
        },
        plugins: {
          legend: {
            display: false,
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            position: 'left',
            suggestedMax: 5,
            ticks: {
              stepSize: 1,
              callback: function (value) {
                if (value % 1 === 0) {
                  return value;
                }
              },
            },
            callback: (a) => {
              console.log(a);
            }
          },

          y2: {
            beginAtZero: true,
            position: 'right',
            type: 'linear',
            display: true,
            suggestedMax: 100,
            ticks: {
              stepSize: 1000,
            },
          },

          x: {
            ticks: {
              autoSkip: false,
              major: {
                enabled: true
              },
              // color: function(context) {
              //   return context.tick && context.tick.major ? '#FF0000' : 'rgba(0,0,0,0.1)';
              // },
              font: function (context) {
                if (context.tick?.major) {
                  return {
                    weight: 'bold',
                  };
                }
              }
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),
    totalPurchases() {

      let amount = 0;
      this.companyPurchaseStatistics.forEach((s) => {
        amount += parseFloat(s.amount);
      })

      return amount;

    },
    maxHeight() {
      return Math.max(this.chartData.datasets[0].data) || 5;
    },
    chartData() {

      let data = {
        labels: [],
        datasets: [
          {
            label: this.$t("vendorManagementChart.purchaseChart.label1"),
            backgroundColor: '#7FCEBB',
            data: [],
            type: 'bar',
            hidden: this.visibleLabels.indexOf(this.$t("vendorManagementChart.purchaseChart.label1")) < 0,
            order:4,
            borderRadius: {
              topLeft: Number.MAX_VALUE,
              topRight: Number.MAX_VALUE
            },
          },
          {
            label: this.$t("vendorManagementChart.purchaseChart.label2"),
            backgroundColor: '#CACFD7',
            data: [],
            type: 'bar',
            hidden: this.visibleLabels.indexOf(this.$t("vendorManagementChart.purchaseChart.label2")) < 0,
            order:3,
            borderRadius: {
              topLeft: Number.MAX_VALUE,
              topRight: Number.MAX_VALUE
            },
          },
          {
            label: this.$t("vendorManagementChart.purchaseChart.label3"),
            backgroundColor: '#C45BAF',
            borderColor: '#C45BAF',
            lineTension: 0.5,
            data: [],
            yAxisID: 'y2',
            hidden: this.visibleLabels.indexOf(this.$t("vendorManagementChart.purchaseChart.label3")) < 0,
            order: 2,
            pointStyle: 'circle',
            pointRadius: 3,
            pointHoverRadius: 6,
            pointBackgroundColor: '#ffffff',
          },
          {
            label: this.$t("vendorManagementChart.purchaseChart.label4"),
            backgroundColor: '#6390F8',
            borderColor: '#6390F8',
            lineTension: 0.5,
            data: [],
            yAxisID: 'y2',
            hidden: this.visibleLabels.indexOf(this.$t("vendorManagementChart.purchaseChart.label4")) < 0,
            order: 1,
            pointStyle: 'circle',
            pointRadius: 3,
            pointHoverRadius: 6,
            pointBackgroundColor: '#ffffff',
          }
        ]
      };

      let total = 0;

      this.companyPurchaseStatistics.forEach((s) => {
        total+=s.amount;
        data.labels.push(dayjs(s.reportDate).format('DD MMM'));
        data.datasets[0].data.push(s.successful);
        data.datasets[1].data.push(s.unsuccessful);
        data.datasets[2].data.push(s.amount);
        data.datasets[3].data.push(total);
        //data.datasets[2].data.push(Math.random() * 10000);
      })
      return data;
    }
  },
  mounted() {
    this.getFormFormSectorStatistics();
  },

  methods: {
    getFormFormSectorStatistics() {
      getCompanyPurchaseStatistics(this.token).then(list => {
        this.companyPurchaseStatistics = list;
        this.ready = true;
      })

    },

  }

}
</script>
